module.exports = __webpack_public_path__ + "img/error.85f1fa26.jpg";